import { render } from "./UserExternalTransactions.vue?vue&type=template&id=51f89c93&scoped=true&ts=true"
import script from "./UserExternalTransactions.vue?vue&type=script&lang=ts"
export * from "./UserExternalTransactions.vue?vue&type=script&lang=ts"

import "./UserExternalTransactions.vue?vue&type=style&index=0&id=51f89c93&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f89c93"]])

export default __exports__